<h1 mat-dialog-title i18n="@@printPreview">Print Preview</h1>

<mat-dialog-content style='display: contents!important;'>
  <div style="width: 99%; height: 100%;">
    <iframe
      [src]="link"
      style="width: 100%; height: calc(100% - 50px);"></iframe>
  </div>

</mat-dialog-content>
